<div>
    <cp-sort-component #sortComponent [orgColId]="orgColId" [colId]="colId" (onSortRequested)="onSortRequested($event)"></cp-sort-component>
</div>